import { BankAccountValidation } from '@/components/modules/DocumentsValidation/components/steps/BankAccountValidation/BankAccountValidation';
import { Confirmation } from '@/components/modules/DocumentsValidation/components/steps/Confirmation/Confirmation';
import { DocumentIdValidation } from '@/components/modules/DocumentsValidation/components/steps/DocumentIdValidation/DocumentIdValidation';
import { DocumentNumberValidation } from '@/components/modules/DocumentsValidation/components/steps/DocumentNumberValidation/DocumentNumberValidation';
import { IncomeValidation } from '@/components/modules/DocumentsValidation/components/steps/IncomeValidation/IncomeValidation';
import { VideoIdValidation } from '@/components/modules/DocumentsValidation/components/steps/VideoIdValidation/VideoIdValidation';
import { ValidationStep } from '@/components/modules/DocumentsValidation/types/ValidationStep';

interface DocumentsValidationStepsProps {
  step: ValidationStep;
  onNext: () => void;
}

export const DocumentsValidationSteps = ({ step, onNext }: DocumentsValidationStepsProps) => {
  return (
    <>
      {step === ValidationStep.DOCUMENT_NUMBER_VALIDATION && <DocumentNumberValidation onNext={onNext} />}
      {step === ValidationStep.DOCUMENT_ID_VALIDATION && <DocumentIdValidation onNext={onNext} />}
      {step === ValidationStep.VIDEO_ID_VALIDATION && <VideoIdValidation onNext={onNext} />}
      {step === ValidationStep.BANK_ACCOUNT_VALIDATION && <BankAccountValidation onNext={onNext} />}
      {step === ValidationStep.INCOME_VALIDATION && <IncomeValidation onNext={onNext} />}
      {step === ValidationStep.CONFIRMATION && <Confirmation />}
    </>
  );
};
